export default __webpack_public_path__ + "static/media/Beetroot.f516c3bc.jpg";